import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';

import NotFound from '../404';
import PageSpinner from '../../components/PageSpinner';
import Helmet from '../../components/common/Helmet';
import Inspiration from '../../components/inspirations/Inspiration';
import InspirationHeader from '../../components/inspirations/InspirationHeader';
import InspirationList from '../../components/inspirations/InspirationList';
import useTranslate from '../../hooks/useTranslate';
import { useInspiration, useInspirations } from '../../services/apis/inspirations/api';
import { InspirationType } from '../../services/apis/inspirations/types';

const SUGGESTIONS_LIMIT = 3;

function InspirationPage() {
  const { translate, activeLanguage } = useTranslate();
  const { releaseDate = '', normalizedTitle = '' } =
    useParams<Pick<InspirationType, 'releaseDate' | 'normalizedTitle'>>();
  const language = activeLanguage.code;

  const {
    data: inspiration,
    isFetching,
    isFetched,
  } = useInspiration({ language, releaseDate, normalizedTitle });

  let { data: inspirations } = useInspirations(
    {
      language,
      category: inspiration?.category,
      limit: SUGGESTIONS_LIMIT + 1,
    },
    !!inspiration?.category
  );

  inspirations = inspirations
    ?.filter(item => item.id !== inspiration?.id)
    .slice(0, SUGGESTIONS_LIMIT);

  if (isFetching || !isFetched) {
    return <PageSpinner />;
  }

  if (!inspiration) {
    return <NotFound />;
  }

  return (
    <>
      <Helmet
        title={inspiration.meta.title || inspiration.title}
        description={inspiration.meta.description}
      />
      <Container className="px-3 pt-3 pb-5 min-vh-100" style={{ paddingBottom: 80 }}>
        <InspirationHeader inspiration={inspiration} />
        <Inspiration inspiration={inspiration} />
        {!!inspirations?.length && (
          <div style={{ marginTop: 80 }}>
            <h2>{String(translate(`Inspirations.categories.${inspiration.category}`))}</h2>
            <InspirationList inspirations={inspirations} />
          </div>
        )}
      </Container>
    </>
  );
}

export default InspirationPage;
